import { environment } from '../../../environments/environment';

export type FeatureFlag = 'materials' | 'demo' | 'actionMap';

function devOnly(): boolean {
  return !environment.production;
}

const FEATURE_FLAGS: Readonly<Record<FeatureFlag, boolean>> = {
  // Read from environment.features rather than `!production`: the deployed dev
  // build sets production: true for its optimisations, so the old rule hid
  // Materials on the dev server as well as in production.
  materials: environment.features.materials || environment.demo.enabled,
  demo: environment.demo.enabled || devOnly(),
  actionMap: environment.mapsKey.length > 0,
};

export function isFeatureEnabled(flag?: FeatureFlag): boolean {
  if (!flag) {
    return true;
  }

  return FEATURE_FLAGS[flag];
}
